import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import AuthHeader from "@/components/AuthHeader";
import { PrimaryButton, SecondaryButton } from "@/components/brand";
import Footer from "@/components/Footer";

export default function ApplicationSubmitted() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <AuthHeader tag="APPLICATION" />
      <div className="flex-1 flex items-center">
        <div className="mx-auto w-full max-w-lg px-6 py-16" data-testid="application-submitted">
          <span className="grid h-12 w-12 place-items-center bg-orange-500 rounded-full mb-8">
            <Check className="h-6 w-6 text-white" strokeWidth={3} />
          </span>
          <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-gray-400 mb-4">[RECEIVED]</div>
          <h1 className="headline text-4xl lg:text-5xl text-[#0a0a0a]">Application submitted.</h1>
          <p className="mt-6 text-base text-gray-500 leading-relaxed">
            Your application is now <span className="font-semibold text-[#0a0a0a]">pending review</span>. Our operations team reviews every
            applicant — we'll email you within <span className="font-semibold text-[#0a0a0a]">48 hours</span> with a decision.
          </p>
          <div className="mt-6 border border-gray-200 p-5">
            <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-500 mb-2">Track your status</div>
            <p className="text-sm text-gray-600">You're signed in to your driver portal. Check your application status any time.</p>
          </div>
          <div className="mt-8 flex gap-3">
            <PrimaryButton as={Link} to="/driver" data-testid="submitted-status-button">Check status</PrimaryButton>
            <SecondaryButton as={Link} to="/">Back to home</SecondaryButton>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
